"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sentry = exports.useSentry = void 0;
exports.initSentry = initSentry;
exports.captureException = captureException;
exports.setSentryUser = setSentryUser;
var Sentry = __importStar(require("@sentry/browser"));
exports.Sentry = Sentry;
var sentryDsn = __importStar(require("./sentryDsn.json"));
var revision_json_1 = require("../revision.json");
exports.useSentry = process.env.NODE_ENV === "production";
function initSentry(name) {
    if (exports.useSentry)
        Sentry.init({ dsn: sentryDsn[name], release: revision_json_1.revision });
}
function captureException(e) {
    if (exports.useSentry)
        Sentry.captureException(e);
}
function setSentryUser(user) {
    Sentry.configureScope(function (scope) { return scope.setUser(user); });
}
